import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentUser } from 'selectors/authentication';
import ServiceProvidersDetails from 'components/admin/service-providers/ServiceProvidersDetails.js';

class ServiceProviderTeam extends Component {
  render() {
    const { currentUser } = this.props;
    return (
      <ServiceProvidersDetails
        id={currentUser.accountable_id}
        type={currentUser.accountable_type}
      />
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
  };
})(ServiceProviderTeam);



// WEBPACK FOOTER //
// ./src/components/admin/team/ServiceProviderTeam.js